import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/DashboardLayout';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/components-overview/dashboard')));

// render - utilities
const Typography = Loadable(lazy(() => import('pages/components-overview/Typography')));
const Color = Loadable(lazy(() => import('pages/components-overview/Color')));
const Shadow = Loadable(lazy(() => import('pages/components-overview/Shadow')));
const AntIcons = Loadable(lazy(() => import('pages/components-overview/AntIcons')));
const Print = Loadable(lazy(() => import('pages/components-overview/Print')));
const FileUpload = Loadable(lazy(() => import('pages/components-overview/FileUpload')));
const FormSearchTest = Loadable(lazy(() => import('pages/components-overview/FormSearchTest')));

const DashboardRoutes = {
    path: '/overview',
    element: <DashboardLayout />,
    children: [
        {
            path: 'dashboard',
            element: <DashboardDefault />
        },
        {
            path: 'color',
            element: <Color />
        },
        {
            path: 'shadow',
            element: <Shadow />
        },
        {
            path: 'typography',
            element: <Typography />
        },
        {
            path: 'print',
            element: <Print />
        },
        {
            path: 'icons/ant',
            element: <AntIcons />
        },
        {
            path: 'file-upload',
            element: <FileUpload />
        },
        {
            path: 'form-search',
            element: <FormSearchTest />
        }
    ]
};

export default DashboardRoutes;
